'use strict';

var $ = require('jquery');

/* ========================================================
 * 		jQuery
 *
 * If you need jQuery in a JS file add this to the top of that file:
 * 		var $ = require('jquery');
 * If some JS code MUST have jQuery globally accessible then
 * add the following line inside this file (index.js).
 * 		var $ = window.jQuery = require('jquery');
 ========================================================= */

/* ========================================================
 * 		Requires
 ========================================================= */
// Browser specific detection
var detectBrowser = require('./lib/detectBrowser.js');
detectBrowser.addStyleClasses();

// Polyfills
require('./polyfills/requestAnimationFrame.js');
require('./polyfills/classList.js');
require('./polyfills/nodeListForEach.js');

// Lib
require("@plaudit/jsf-ajax-adapters/dist/jQuery").default.init();

// Analytics
var Analytics = require('@plaudit/analytics').Analytics;
Analytics.getInstance();

/* ========================================================
 * 		Component Setup
 ========================================================= */
var myGallery = new (require('./site/Gallery.js'));
myGallery.init();

var myAccordion = new (require('./site/Accordion.js'));
myAccordion.init();
$(document).on('jsfAjaxAlways', function() {
	myAccordion.init();
});

require('./site/ResponsiveTables.js').init();

require('./lib/Buttons.js').attachHandlers('.btn--hasSpinner');

require('./site/MegaMenuTracker.js').init();
var Menu = require('./site/MainMenu.js');
var $backToSeeAllConferences = $('.backToSeeAllConferences');
var selectorMatchesConferenceNodes = '.nav--mobilePrimary .node--L1:not(.node--index):not(.backToSeeAllConferences)';
var mobileMenu = new Menu.MobileMenu({
	menu 			: '#menu',
	menuTarget 		: '.menu__inner',
	nodeTarget_slidable : '.childWrap--L2',
	nodeTrigger 	: '.node--hasChild > a, .backToSeeAllConferences > a',
	headTarget 		: '.childWrap__heading',
	triggers 		: '#menuTrigger--open, #menuTrigger--close, #menuOverlay',
	triggerEvent 	: 'click',
	hideSiblingMenuItems: selectorMatchesConferenceNodes,
	collapsable: {
		duration: 400
	},
	styleClass: {
		setup 			: 'hasMenuSetup',
		menuOpen 		: 'hasMenuOpen',
		nodeOpen 		: 'isOpen',
		backWrap 		: 'childWrap__back'
	},
	onNodeChange: function($selectItem, opening) {
		if (opening && $selectItem.hasClass('backToSeeAllConferences')) {
			// Clicked on back. Close current conference node
			mobileMenu.openNode($('.nav--mobilePrimary .node--L1.isOpen'), false);
			return false;
		} else {
			$selectItem = $selectItem.filter(selectorMatchesConferenceNodes);
			if ($selectItem.length === 0)
				return;

			if (opening) {
				$backToSeeAllConferences.addClass('backToSeeAllConferences--conferenceSelected');
			} else {
				$backToSeeAllConferences.removeClass('backToSeeAllConferences--conferenceSelected');
			}
		}
	}
});

require('./lib/Forms.js').init();
require('./site/PeopleGroup.js').init();
require('./site/CountrySelector.js').init();
require('./site/basicMasonry.js').init();
require('./site/ByTheNumbers.js').init();
require('./site/KeyDates.js').init();
require('./site/BoxGroup.js').init();
